import React from 'react';

import { SVGComponentProps } from './svg.types';

const CustomEpicSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.66675 15.1252C8.66675 14.8489 8.77649 14.5839 8.97185 14.3886C9.1672 14.1932 9.43215 14.0835 9.70841 14.0835H15.3334"
          stroke="#BCBEC2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.70841 7.8335H15.3334V16.1668H9.70841C9.43215 16.1668 9.1672 16.0571 8.97185 15.8617C8.77649 15.6664 8.66675 15.4014 8.66675 15.1252V8.87516C8.66675 8.5989 8.77649 8.33394 8.97185 8.13859C9.1672 7.94324 9.43215 7.8335 9.70841 7.8335Z"
          stroke="#BCBEC2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="0.5"
          y="0.5"
          width="23"
          height="23"
          rx="11.5"
          stroke="#BCBEC2"
          strokeDasharray="3 3"
        />
      </svg>
    </span>
  );
};

export default CustomEpicSVG;
